import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', to: '/' },
    { label: '电影分类', to: '/category/action' },
    { label: '电视剧分类', to: '/category/drama' },
    { label: '关于我们', to: '/about' },
  ],
  categories: [
    { label: '动作片', to: '/category/action' },
    { label: '喜剧片', to: '/category/comedy' },
    { label: '科幻片', to: '/category/sci-fi' },
    { label: '剧情片', to: '/category/drama' },
    { label: '恐怖片', to: '/category/horror' },
    { label: '动画片', to: '/category/animation' },
  ],
  articles: [
    { label: '观影指南', to: '/article/article-4' },
    { label: '追剧技巧', to: '/article/article-6' },
    { label: '影视资讯', to: '/article/article-3' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-300">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-movie-2-line text-2xl text-primary-400"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white">
                  草民影院
                </span>
              </div>
              <p className="text-sm leading-relaxed text-foreground-400">
                高清电影、超清电视剧，蓝光画质1080P在线观看，高清不卡，流畅不缓冲，即点即看。草民影院为您提供最优质的在线观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-white mb-4">
                快速导航
              </h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.navigation.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-white mb-4">
                影视分类
              </h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.categories.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-white mb-4">
                热门资讯
              </h4>
              <ul className="flex flex-col gap-2">
                {footerLinks.articles.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
              <h4 className="font-heading text-base font-bold text-white mt-6 mb-3">
                联系我们
              </h4>
              <p className="text-sm text-foreground-400">
                <i className="ri-mail-line mr-1"></i>
                contact@uwkltw.cn
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 草民影院 版权所有 | 高清电影 超清电视剧 蓝光画质1080P在线观看
            </p>
            <p className="text-xs text-foreground-500">
              高清不卡 · 流畅不缓冲 · 即点即看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}